import { Input, Popover, Tag } from "antd";
import React, { useMemo, useRef, useState } from "react";
import { CloseOutlined, PlusOutlined } from "@ant-design/icons";

import type { InputRef } from "antd";

interface TypeTagsInputProps<T = string[]> {
  value?: T;
  /**
   * @param max 最多几个tag
   */
  max?: number;
  onChange?(value: T): void;
  /**
   * @param suggestedTags 建议标签
   */
  suggestedTags?: string[];
}

/**
 * @name TagsInput 标签输入
 */
const TagsInput: React.FC<TypeTagsInputProps> = ({
  max,
  onChange,
  value = [],
  suggestedTags = [],
}) => {
  const ref = useRef<InputRef>();

  const [open, setOpen] = useState(false);
  const [input, setInput] = useState<string>();
  const [popover, setPopover] = useState(false);

  function onDelete(i: number) {
    value?.splice(i, 1);
    onChange?.([...value]);
    setPopover(false);
  }

  function onBlur() {
    setOpen(false);
    setPopover(false);
    setInput(undefined);
  }

  function onConfirm(e: React.KeyboardEvent<HTMLInputElement>) {
    e.preventDefault();
    if (input) onChange?.([...value, input]);
    onBlur();
  }

  function onSuggestedTag(val: string) {
    onChange?.([...value, val]);
  }

  function onShow() {
    setOpen(true);
    setTimeout(() => ref.current?.focus());
  }

  const OPTIONA_TAGS = useMemo(
    () => suggestedTags.filter((v) => !value.includes(v)),
    [value, suggestedTags],
  );

  return (
    <div className="website-tags">
      {value?.length + 1 <= max && (
        <>
          {open ? (
            <Input
              ref={ref}
              allowClear
              type="text"
              size="small"
              value={input}
              maxLength={50}
              onBlur={onBlur}
              onPressEnter={onConfirm}
              className="website-tags-input"
              placeholder="Enter your specialty"
              onChange={(e) => setInput(e.target.value)}
            />
          ) : (
            <Popover
              open={OPTIONA_TAGS?.length && popover}
              onOpenChange={(e) => setPopover((b) => !b)}
              title="Suggested tags"
              content={
                <div className="website-tags website-tags-suggestion">
                  {OPTIONA_TAGS.map((v) => (
                    <span onClick={() => onSuggestedTag(v)} key={v}>
                      <span>{v}</span>
                    </span>
                  ))}
                </div>
              }
            >
              <Tag
                onClick={onShow}
                className="website-tags-insert"
                icon={<PlusOutlined rev={undefined} />}
              >
                Add your specialty...
              </Tag>
            </Popover>
          )}
        </>
      )}

      {value.map((v, i) => (
        <span>
          <span>{v}</span>
          <CloseOutlined onClick={() => onDelete(i)} rev={undefined} />
        </span>
      ))}
    </div>
  );
};

export default TagsInput;
